import MyFriendsMap from "../components/MyFriendsMap";

export default function MyFriends() {
  return (
    <div className="">
      <div className="text-black dark:text-white lg:p-10">
        <MyFriendsMap />
      </div>
    </div>
  );
}